class ShareGrp {
	constructor(type) {
		switch(type) {
			case 'heroes':
				this._title = _("Heroes");
				this._icon = span('i-lg i-hero');
				break;
			case 'teams':
				this._title = _("Teams");
				this._icon = span('i-lg i-teams');
				break;
			case 'communities':
				this._title = _("Communities");
				this._icon = span('i-lg i-community');
				break;
		}

		this._rows = [];

		this._elem = div('accordion-item', [
			htm('h2', 'accordion-header', [
				btn('accordion-button', [
					this._icon,
					span(null, this._title)
				], null, {
					'data-bs-toggle': 'collapse',
					'data-bs-target': '#accordion-' + type,
					'aria-expanded': 'true',
					'aria-controls': 'accordion-' + type
				}),
			]),
			div('accordion-collapse collapse show', 
				this._rowsContainer = div('container-flush'), null, {
				'id': 'accordion-' + type,
				'data-bs-parent': '#sharing-accordion'
			})
		]);
	}

	get elem() {return this._elem;}

	addRow (elem) {
		this._rowsContainer.appendChild(elem);
	}
}
